import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import useStepParam from '@lib/hooks/useStepParam';
import { Steps } from '@lib/enums/form';

export interface Props {
  onCancel: () => void;
  stepsCount: Steps;
  loading: boolean;
}

export default function DocumentImportFormActions({
  onCancel,
  stepsCount,
  loading,
}: Props) {
  const { t } = useTranslation();
  const [step, setStep] = useStepParam();
  const isLastStep = step === stepsCount;

  const navigateToNextStep = () => {
    const nextStep = step + 1;
    if (nextStep <= stepsCount) {
      setStep(nextStep);
    }
  };

  const navigateToPreviousStep = () => {
    if (step > Steps.step1) {
      setStep(step - 1);
    }
  };

  const cancelOrBack =
    step > Steps.step1 ? (
      <Button
        key="back"
        buttonType={ButtonTypes.primaryOutlined}
        buttonText={t('back')}
        leftIcon="arrow_back"
        fullWidth
        disabled={loading}
        onClick={navigateToPreviousStep}
      />
    ) : (
      <Button
        key="cancel"
        buttonType={ButtonTypes.secondaryOutlined}
        buttonText={t('cancel')}
        leftIcon="close"
        fullWidth
        disabled={loading}
        onClick={onCancel}
      />
    );

  const nextOrSubmit = isLastStep ? (
    <Button
      key="submit"
      type="submit"
      buttonType={ButtonTypes.primaryFilled}
      buttonText={t('import-documents')}
      leftIcon="check"
      fullWidth
      disabled={loading}
    />
  ) : (
    <Button
      key="next"
      buttonType={ButtonTypes.primaryFilled}
      buttonText={t('continue')}
      rightIcon="arrow_forward"
      fullWidth
      onClick={navigateToNextStep}
    />
  );

  return (
    <ActionsRow
      actions={[
        cancelOrBack,
        <div key="spacer-1" />,
        <div key="spacer-2" />,
        nextOrSubmit,
      ]}
    />
  );
}
